import _ from 'lodash';
import * as actionTypes from '../actions/actionTypes';
import {updateObject} from '../utility';

const initialState = {
  pageData: null,
  details: [],
  searchMode: false,
  searchParams: {
    string: '',
    limit: 10,
    current: 0,
    submit: false,
    terms: [],
  },
  selectedItem: null,
  editor: null,
  bookmarks: {
    folders: {},
    bookmarks: {},
    shared_bookmarks: {},
  },
  sharedFolderMode: {
    resultsPage: false,
    contextBar: false,
    currentBookmark: null,
  },
  editorChanges: {},
  removedArticles: [],
  treeData: [],
};

const editorChanges = (state, action) => {
  const changes = _.mapValues(action.editorChanges, (val, key) => {
    if (state.editorChanges[key]) {
      return {...state.editorChanges[key], ...val};
    }
    return val;
  });
  return updateObject(state, {
    editorChanges: updateObject(state.editorChanges, changes),
  });
};

// Reducer function.
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_PAGE_DATA:
      return updateObject(state, {pageData: action.pageData});
    case actionTypes.SET_DOC_DETAILS:
      return updateObject(state, {details: action.details});
    case actionTypes.SET_SELECTED_ITEM:
      return updateObject(state, {selectedItem: action.selectedItem});
    case actionTypes.SET_EDITOR:
      return updateObject(state, {editor: action.editor});
    case actionTypes.SET_EDITOR_CHANGES:
      return editorChanges(state, action);
    case actionTypes.SET_DOC_SEARCH_MODE:
      return updateObject(state, {searchMode: action.searchMode});
    case actionTypes.SET_DOC_SEARCH_PARAMS:
      return updateObject(state, {
        searchParams: updateObject(state.searchParams, action.searchParams),
      });
    case actionTypes.SET_BOOKMARKS:
      return updateObject(state, {
        bookmarks: updateObject(state.bookmarks, action.bookmarks),
      });
    case actionTypes.SET_SHARED_FOLDER_MODE:
      return updateObject(state, {
        sharedFolderMode: updateObject(state.sharedFolderMode, action.sharedFolderMode),
      });
    case actionTypes.SET_DOC_TREE_DATA:
      return updateObject(state, {treeData: action.treeData});
    case actionTypes.REMOVE_TREE_ARTICLE:
      state.removedArticles.push(action.id);
      return updateObject(state, {removedArticles: state.removedArticles});

    default:
      return state;
  }
};

export default reducer;
